const data=[
    {
        heading:"About",
        img:``,
        desc:"Finished watching yet another anime and searching for another...\n\n\nAnimo.io provides hundreds of anime for you to choose. Search for an anime and add it to your watchlist.   ",
        left:true
    },
    {
        heading:"Genre",
        img:``,
        desc:" Looking for something more specific? Try searching by genres. Start searching by genres ... Choose from a wide range of different genres ",
        left:false
    },
    {
        heading:"Search Name",
        img:``,
        desc:"Search Anime by name. We have over thousands of anime for you to choose from",
        left:true
    }

]
export default data